<template>
  <div>
    <div>
      <j-dict-select-tag
        style="width: 170px; margin-right: 15px"
        placeholder="请选择年级"
        v-model="queryParam.gradeId"
        dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
        :isShowEmpty="false"
        @select="$set(queryParam, 'classId', undefined)"
      />
      <j-dict-select-tag
        style="width: 170px; margin-right: 15px"
        placeholder="请选择班级"
        v-model="queryParam.classId"
        :dictCode="
          'school_class,name,id,grade_id=' + (!queryParam.gradeId ? -1 : queryParam.gradeId)
        "
        :async="true"
        :disabled="!queryParam.gradeId"
        :isShowEmpty="false"
      />
      <a-input-search
        v-model="queryParam.name"
        placeholder="请输入学生名字"
        style="width: 170px; margin-left: 15px"
        @change="searchName"
      />
      <a-button type="primary" style="margin-left: 15px" @click="loadData">查询</a-button>
    </div>
    <TableList
      style="width: 100%; margin-top: 10px"
      :columns="columns"
      :tableData="tableData"
      :loading="loading"
      :scroll="{}"
      :pagination="pagination"
      @change="handleTableChange"
    >
      <template #action="{ record }">
        <!-- <span style="color: #1783e8; cursor: pointer" @click="viewProgress(record)">查看报告</span> -->
      </template>
    </TableList>
  </div>
</template>

<script>
import TableList from '@/components/chart/TableList'
import { simpleDebounce } from '@/utils/util'
import { getAction } from '@api/manage'

export default {
  name: 'ParentContactList',
  components: {
    TableList,
  },
  data() {
    return {
      queryParam: {},
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          align: 'center',
        },
        {
          title: '班级',
          dataIndex: 'studentClass',
          align: 'center',
        },
        {
          title: '学生',
          dataIndex: 'name',
          align: 'center',
        },
        {
          title: '提醒等级',
          dataIndex: 'careList_dictText',
          align: 'center',
        },
        {
          title: '关爱名单',
          dataIndex: 'teacher_name',
          align: 'center',
          customRender: (_, record) => {
            return record.careList > 0 ? '是' : '否'
          },
        },
        {
          title: '提醒次数',
          dataIndex: 'warnNum',
          align: 'center',
        },
        {
          title: '家长电话',
          dataIndex: 'phone',
          align: 'center',
          customRender: (_, record) => {
            return record.phone.length >= 25 ? (
              <a-tooltip>
                <template slot="title">{record.phone}</template>
                {record.phone.substring(0, 25) + '...'}
              </a-tooltip>
            ) : (
              record.phone
            )
          },
        },
        {
          title: '邮箱',
          dataIndex: 'teacher_name',
          align: 'center',
        },
        {
          title: '家长访问次数',
          dataIndex: 'visitCnt',
          align: 'center',
        },
        // {
        //   title: '操作',
        //   dataIndex: 'action',
        //   align: 'center',
        //   scopedSlots: { customRender: 'action' },
        // },
      ],
      tableData: [
        {
          index: 1,
          name: '101',
          teacher_name: '张三',
        },
      ],
      loading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '50'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        // showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      const res = await getAction('/studentEment/studentEment/parentConcat', {
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize,
        ...this.queryParam,
      })
      if (res.success) {
        this.$set(this.pagination, 'total', res.result.total)
        this.tableData = res.result.records?.map((item, index) => ({
          ...item,
          index: index + 1,
        }))
      }
      this.loading = false
    },
    handleTableChange(page) {
      this.pagination = page
      this.loadData()
    },
    searchName: simpleDebounce(function (event) {
      this.loadData()
    }, 500),
  },
}
</script>
<style scoped lang="less"></style>
